import React from 'react';

type ErrorTextType = {
  errorText: string;
};

const FieldErrorText = ({ errorText }: ErrorTextType) => (
  <small className="p-error block">{errorText}</small>
);

export default FieldErrorText;
